import React, { useCallback, useEffect, useRef, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "./admin.css";
import "./usermember.css";
import { faAngleRight, faChevronLeft, faChevronRight, faCopy } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { apiService } from '../../services/apiService';
import Select from 'react-select';
import dayjs from 'dayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { getCountryCallingCode } from 'libphonenumber-js';
import { Modal } from 'react-bootstrap';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import KbAccessMemeber from './KbAccessMemeber';
function UserMemberEdit() {
    const UserRoles = localStorage.getItem('role');
    const allowedCountries = ['US', 'IN', 'CA', 'DE', 'AU', 'GB', 'PK'];
    const maxPhoneLengths = { 
        US: 10,  // United States
        IN: 10,  // India
        CA: 10,  // Canada
        DE: 11,  // Germany
        AU: 9,   // Australia
        GB: 10,  // United Kingdom
        PK: 10   // Pakistan
    };
    const { id } = useParams(); // Extract ID from URL params
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [btnloading, setBtnLoading] = useState(false);
    const [deleteLoader, setDeleLoading] = useState(false);
    const [suspendLoader, setsuspendLoading] = useState(false);
    // State for roles and form data
    // const [rolesOptions, setRolesOptions] = useState([]);
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        address: '',
        dob: null,
        phone_number: '',
        business_number: '',
        email: '',
        password: '',
        password_confirmation: '',
        // roles: [], 
        profile: null,

        start_date: null,
        industry_start_date: null,
        manager_id: null,
        job_title: null,
        is_review: 0,
        partnership_status: 0,

        primary_department:"",
        industry_sector:"",
        linkedin_url:"",
        is_whatsapp:"",
        is_business:"",
        whatsapp_number:"",
        business_whatsapp_number:"",
    });
    const [value, setValue] = useState(dayjs(null));
    const [value2, setValue2] = useState(dayjs(null));
    const [value3, setValue3] = useState(dayjs(null));
    const [preview, setPreview] = useState(null);
    const [suspends, setSuspends] = useState(null);
    const [errors, setErrors] = useState({});
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [passwordVisible2, setPasswordVisible2] = useState(false);
    const [errorsmessage, setErrorsMessage] = useState('');
    const [activeTab, setActiveTab] = useState("group");
    const [groupData, setGroupData] = useState([]);
    const [paginatedata2, setPaginateData2] = useState({});
    const [selectedRecord2, setShowRecord2] = useState(20);
    const [currentPage2, setCurrentPage2] = useState(1);
    const [tabLoading, setTabLoading] = useState(false);
    const [permissionData, setPermissionData] = useState([]);
    const [paginatedata, setPaginateData] = useState({});
    const [selectedRecord, setShowRecord] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);
    const [managerList, setManagers] = useState([]);
    const [subAdminData, setSubAdmindata] = useState([]);
    const [selectedManager, setSelectedManager] = useState(null);


    const fetchGroupData = useCallback(async (params = {}) => {
        setTabLoading(true);
        try {
            const defaultParams = {
                page: 1,
            };
            const finalParams = { ...defaultParams, ...params, per_page: params?.per_page ?? selectedRecord, };

            const response = await apiService.postRequest(`admin/user-permissions-list/${id}`, finalParams);
            setPermissionData(response.data);
            setPaginateData(response.meta);
        } catch (error) {
            console.error('Error fetching tab data:', error);
        }finally {
            setTabLoading(false);
        }
    }, [id, selectedRecord]);

    // Handle page change
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchGroupData({ page: newPage });
    };

    useEffect(() => {
        fetchGroupData();
    }, [fetchGroupData]);

    const fetchPermissionData = useCallback(async (params = {}) => {
        setTabLoading(true);
        try {
            const defaultParams = {
                page: 1,
            };
            const finalParams = { ...defaultParams, ...params,  per_page: params?.per_page ?? selectedRecord2, };

            const response = await apiService.postRequest(`admin/user-roles-list/${id}`, finalParams);
            setGroupData(response.data);
            setPaginateData2(response.meta);
        } catch (error) {
            console.error('Error fetching tab data:', error);
        }finally {
            setTabLoading(false);
        }
    }, [id, selectedRecord2]);

    // Handle page change
    const handlePageChange2 = (newPage) => {
        setCurrentPage2(newPage);
        fetchPermissionData({ page: newPage });
    };

    useEffect(() => {
        fetchPermissionData();
    }, [fetchPermissionData]);
    
    const fetchUserData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await apiService.getRequest(`/admin/users/${id}`);
            if (response.success) {
                const user = response?.data?.user;
                setPreview(user.profile);
                setSubAdmindata(user);
                setSuspends(user.suspended);
                setFormData({
                    first_name: user.first_name || '',
                    last_name: user.last_name || '',
                    address: user.address || '',
                    dob: user.dob || null,
                    phone_number: user.phone_number || '',
                    business_number: user.business_number || '',
                    email: user.email || '',

                    manager_id: user.manager_id || "",
                    job_title: user.job_title || "",
                    is_review: user.is_review || 0,
                    partnership_status: user.partnership_status || "",
                    start_date: user.start_date || null,
                    industry_start_date: user.industry_start_date || null,

                    primary_department: user.details?.primary_department || "",
                    industry_sector: user.details?.industry_sector || "",
                    linkedin_url: user.details?.linkedin_url || "",
                    is_whatsapp: user.details?.is_whatsapp === 0 ? 0 : 1,
                    is_business: user.details?.is_business === 0 ? 0 : 1,
                    whatsapp_number: user.details?.whatsapp_number || "",
                    business_whatsapp_number: user.details?.business_whatsapp_number || "",
                    
                });
                if (user.dob) {
                    const parsedDob = dayjs(user.dob, 'YYYY-MM-DD');
                    if (parsedDob.isValid()) {
                        setValue(parsedDob); 
                    }
                }
                if (user.start_date) {
                    const parsedDate = dayjs(user.start_date, 'YYYY-MM-DD');
                    if (parsedDate.isValid()) {
                        setValue2(parsedDate); 
                    }
                }
                if (user.industry_start_date) {
                    const parsedDate = dayjs(user.industry_start_date, 'YYYY-MM-DD');
                    if (parsedDate.isValid()) {
                        setValue3(parsedDate); 
                    }
                }
                if (user && user.manager_id) {
                    const selectedManger = managerList && managerList.find((manager) => manager.id === user.manager_id);
                    if (selectedManger) {
                        setSelectedManager({ label: selectedManger.name, value: selectedManger.id });
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching user data", error);
        }finally {
            setLoading(false);
        }
    }, [id, managerList]);
    useEffect(() => {
        fetchUserData();
    }, [fetchUserData]);

    const handleSuspend = async (memberId, isSuspended) => {
        setsuspendLoading(true);
        try {
            await apiService.postRequest(`/admin/users/${memberId}/suspend`);
            if (isSuspended) {
                toast("Sub Admin Unsuspended successfully!");
            } else {
                toast("Sub Admin Suspended successfully!");
            }
            fetchUserData();
        } catch (err) {
            toast.error(`Failed to ${isSuspended ? "unsuspend" : "suspend"} Sub Admin`);
        }finally{
            setsuspendLoading(false);
        }
    };


    useEffect(() => {
        const fetchData = async () => {
            const userParam = {
                user_id : Number(id)
            }
            const response = await apiService.postRequest(`manager_list`, userParam);
            if (response.success) {
                setManagers(response.data);
            }
        };
        fetchData();
    }, [id]);
    const handleManagerChange = (selectedOption) => {
        setSelectedManager(selectedOption);
        handleInputChange({
            target: {
                name: 'manager_id',
                value: selectedOption ? selectedOption.value : ''
            }
        });
    };
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData({ ...formData, profile: file });
            const reader = new FileReader();
            reader.onloadend = () => setPreview(reader.result);
            reader.readAsDataURL(file);
        }
    };
    const handlePhoneChange = (value, fieldName) => {
        if (value) {
            const country = allowedCountries.find(
                (c) => value.startsWith(`+${getCountryCallingCode(c)}`)
            ) || 'US';

            const countryCode = getCountryCallingCode(country);
            const phoneWithoutCode = value.replace(`+${countryCode}`, '').replace(/\D/g, '');
            const maxLength = maxPhoneLengths[country];

            // Allow input if we're under the max length OR if we're just updating the same field
            // This prevents blocking when the length equals maxLength during typing
            if (phoneWithoutCode.length <= maxLength) {
                handleInputChange({ target: { name: fieldName, value } });
            }
            // If over max length, keep the previous valid value
            // The PhoneInput component will handle this gracefully
        } else {
            // Handle empty/cleared input
            handleInputChange({ target: { name: fieldName, value: '' } });
        }
    };
    const handleKeyDown = (event, fieldName) => {
        const { key } = event;
        const currentValue = formData[fieldName] || ''; // Use dynamic field name
        const country = allowedCountries.find(
            (c) => currentValue.startsWith(`+${getCountryCallingCode(c)}`)
        ) || 'US';

        const maxLength = maxPhoneLengths[country];

        // Remove country code and check the actual phone number length
        const phoneWithoutCode = currentValue.replace(`+${getCountryCallingCode(country)}`, '').replace(/\D/g, '');

        if (phoneWithoutCode.length >= maxLength && /\d/.test(key)) {
            event.preventDefault(); // Stop further input
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const handleDateChange = (newValue) => {
        if (newValue) {
            setValue(newValue);
            setFormData({ ...formData, dob: newValue.format('YYYY-MM-DD') });
    
            // Clear the error for dob if a valid date is entered
            if (errors.dob) {
                setErrors({ ...errors, dob: '' });
            }
        } else {
            setValue(null);
            setFormData({ ...formData, dob: '' }); // Clear the value if null
        }
    };
    const handleDateChange2 = (newValue) => {
        if (newValue) {
            setValue2(newValue);
            setFormData({ ...formData, start_date: newValue.format('YYYY-MM-DD') });
            
            if (errors.start_date) {
                setErrors({ ...errors, start_date: '' });
            }
        } else {
            setValue2(null);
            setFormData({ ...formData, start_date: '' }); // Clear the value if null
        }
    };
    const handleDateChange3 = (newValue) => {
        if (newValue) {
            setValue3(newValue);
            setFormData({ ...formData, industry_start_date: newValue.format('YYYY-MM-DD') });
            
            if (errors.industry_start_date) {
                setErrors({ ...errors, industry_start_date: '' });
            }
        } else {
            setValue3(null);
            setFormData({ ...formData, industry_start_date: '' }); // Clear the value if null
        }
    };
    
    const validate = () => {
        const newErrors = {};
        if (!formData.first_name) newErrors.first_name = 'First name is required';
        if (!formData.last_name) newErrors.last_name = 'Last name is required';
        if (!formData.address) newErrors.address = 'Address is required';
        if (!formData.email) newErrors.email = 'Email is required';
        else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email is invalid';
        // if (!formData.phone_number) newErrors.phone_number = 'Phone number is required';
        if (!formData.phone_number) {
            newErrors.phone_number = 'Personal phone number is required';
        } else {
            // Check if the phone number starts with a valid country code
            const hasValidCountryCode = allowedCountries.some(
                (country) => formData.phone_number.startsWith(`+${getCountryCallingCode(country)}`)
            );
            
            if (!hasValidCountryCode) {
                newErrors.phone_number = 'Please select a allowed country code for personal phone number';
            }
        }
        if (!formData.business_number) {
            newErrors.business_number = 'Business phone number is required';
        } else {
            // Check if the phone number starts with a valid country code
            const hasValidCountryCode = allowedCountries.some(
                (country) => formData.business_number.startsWith(`+${getCountryCallingCode(country)}`)
            );
            
            if (!hasValidCountryCode) {
                newErrors.business_number = 'Please select a allowed country code for business phone number';
            }
        }
        if (!formData.dob) newErrors.dob = 'Date of birth is required';
        if (formData.password !== formData.password_confirmation) newErrors.password_confirmation = 'Passwords do not match';
        // if (formData.roles.length === 0) newErrors.roles = 'At least one Group is required';

        const email = formData.email;
        const emailFormat = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailFormat.test(email)) {
            newErrors.email = 'Please enter a valid email address.';
        }

        if (!formData.manager_id) newErrors.manager_id = 'Manager is required';
        if (!formData.start_date) newErrors.start_date = 'Start date is required';
        if (!formData.industry_start_date) newErrors.industry_start_date = 'Industry start date is required';
        if (!formData.job_title) newErrors.job_title = 'Job title is required';
        if (!formData.partnership_status) newErrors.partnership_status = 'Partnership status is required';

        if (!formData.primary_department) newErrors.primary_department = 'Primary department is required';
        if (!formData.industry_sector) newErrors.industry_sector = 'Industry sector is required';
        if (!formData.linkedin_url) newErrors.linkedin_url = 'Linkedin URL is required';
        if (formData.is_whatsapp === "") newErrors.is_whatsapp = 'Phone number support whatsapp is required';
        if (formData.is_business === "") newErrors.is_business = 'Phone number support business whatsapp is required';
        if(formData.is_whatsapp === 0){
            if (!formData.whatsapp_number) {
                newErrors.whatsapp_number = 'Whatsapp number is required';
            } else {
                // Check if the phone number starts with a valid country code
                const hasValidCountryCode = allowedCountries.some(
                    (country) => formData.whatsapp_number.startsWith(`+${getCountryCallingCode(country)}`)
                );
                
                if (!hasValidCountryCode) {
                    newErrors.whatsapp_number = 'Please select a allowed country code for whatsapp number';
                }
            }
        }
        if(formData.is_business === 0){
            if (!formData.business_whatsapp_number) newErrors.business_whatsapp_number = 'Business whatsapp number is required';

            if (!formData.business_whatsapp_number) {
                newErrors.business_whatsapp_number = 'Business whatsapp number is required';
            } else {
                // Check if the phone number starts with a valid country code
                const hasValidCountryCode = allowedCountries.some(
                    (country) => formData.business_whatsapp_number.startsWith(`+${getCountryCallingCode(country)}`)
                );
                
                if (!hasValidCountryCode) {
                    newErrors.business_whatsapp_number = 'Please select a allowed country code for Business whatsapp number';
                }
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;
        setBtnLoading(true);

        const passwordFormat = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+\\|{};:/?.<>])[\w!@#$%^&*()\-_=+\\|{};:/?.<>]{8,}$/;
    
    // Check if the password matches the format
    if (formData.password && !passwordFormat.test(formData.password)) {
        setErrors(prevErrors => ({
            ...prevErrors,
            password: 'Password must be at least 8 characters long, include an uppercase letter, a number, and a special character.',
        }));
        setBtnLoading(false);
        return; // Exit the function if password is invalid
    }
        try {
            const dataToSubmit = {
                ...formData,
                // roles: formData.roles.map(role => role.value),
            };
            
            const formDataToSend = new FormData();
            
            Object.entries(dataToSubmit).forEach(([key, value]) => {
                // if (key === "roles" && Array.isArray(value)) {
                //     value.forEach(roleId => formDataToSend.append("roles[]", roleId));
                // } else {
                    formDataToSend.append(key, value);
                // }
            });

            const response = await apiService.postRequest(`/admin/users/${id}`, formDataToSend, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            if (response.success){
                toast(response.message || 'User updated successfully!');
                navigate("/user/member");
            }else{
                setErrors(response.errors || "");
                setErrorsMessage(response.message || "");
            }
        } catch (error) {   
            console.error("Error updating user data", error);
            setErrorsMessage("Failed to update user.");
        }finally {
            setBtnLoading(false);
        }
    };

    // Toggle password visibility
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    const togglePasswordVisibility2 = () => {
        setPasswordVisible2(!passwordVisible2);
    };

    const [show, setShow] = useState(false);
    const [selectedMemberId, setSelectedMemberId] = useState(null);

    const handleClose = () => setShow(false);
    const handleShow = (memberId) => {
        setSelectedMemberId(memberId);
        setShow(true);
    };
    
    const handleDelete = async () => {  
        setDeleLoading(true);
        try {
            const response = await apiService.deleteRequest(`/admin/users/${selectedMemberId}`);
            if(response && response.success){
                toast(response.message || 'Sub-admin deleted successfully!');
                navigate("/user/member");
            }else{
                toast(response.message || 'Failed to delete Sub-admin!');
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (err) {
            console.log(err,"Failed to delete");
        }finally{
            setDeleLoading(false);
            handleClose();
        }
    };

    const rows2 = groupData && groupData.map((datas, index) => ({
        id: datas.id,
        index: paginatedata2?.from + index,
        groupType: datas.group_type || "N/A",
        groupName: datas.display_name || "N/A",
    }));
    const columns2 = [
        {
            field: 'index',
            headerName: 'S.No',
            minWidth: 300,
            flex: 1,
            filterable: false,
            sortable: false,
        },
        {
            field: 'groupName',
            headerName: 'Group Name',
            minWidth: 400,
            flex: 1,
            filterable: false,
            sortable: false,
        },
        {
            field: 'groupType',
            headerName: 'Group Type',
            minWidth: 400,
            flex: 1,
            filterable: false,
            sortable: false,
            renderCell: (params) => (
                <span style={{textTransform: "capitalize"}}>{params.row.groupType}</span>
            )
        },
    ];

    const rows = permissionData && permissionData.map((datas, index) => ({
        index: paginatedata?.from + index,
        id: datas.id,
        permissionType: datas.tab,
        permissionFor: datas.display_name,
        description: datas.description || "No Description",
    }));
    const columns = [
        {
            field: 'index',
            headerName: 'S.No',
            minWidth: 150,
            flex: 1,
            filterable: false,
            sortable: false,
        },
        {
            field: 'permissionFor',
            headerName: 'Permission For',
            minWidth: 400,
            flex: 1,
            filterable: false,
            sortable: false,
        },
        {
            field: 'permissionType',
            headerName: 'Permission Type',
            minWidth: 400,
            flex: 1,
            filterable: false,
            sortable: false,
        },
        {
            field: 'description',
            headerName: 'Description',
            minWidth: 400,
            flex: 1,
            filterable: false,
            sortable: false,
        },
    ];

    const signatureRef = useRef(null);

  const handleCopy = () => {
    const el = signatureRef.current;
    if (el) {
      const range = document.createRange();
      range.selectNode(el);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand("copy");
      selection.removeAllRanges();
      toast("Signature copied! You can now paste it into your email.");
    }
  };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container justifyContent="center" className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center">
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>User</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/user/member")}>User</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/user/member")}>Sub Admin</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {subAdminData?.format_id}</span>
                    </Grid>
                    {!loading &&
                    <Grid size={{xs:12}} container className="editgrouphead my-4">
                        <h2>{subAdminData?.format_id}</h2>
                    </Grid>}
                </Grid>
                {loading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                    <form className='row justify-content-center w-100' onSubmit={handleSubmit}>
                        <Grid size={{ sm: 11, xs: 12 }} container justifyContent="space-between" className="add_memberfields">
                            {/* Profile Picture Upload */}
                            <Grid size={{ sm: 12, xs: 12 }} container alignItems="center" className="profile_uploadlab mb-5">
                                <div className="profile-upload-wrapper">
                                    <label htmlFor="profile-upload-input" className="profile-upload-label">
                                        {preview ? (
                                            <img src={preview} alt="Profile Preview" className="profile-preview" />
                                        ) : (
                                            <div className="placeholder-icon">
                                                <img src={require('../../assets/cameraicon.svg').default} alt='Upload' />
                                            </div>
                                        )}
                                    </label>
                                    <input
                                        id="profile-upload-input"
                                        type="file"
                                        accept="image/*"
                                        onChange={handleImageChange}
                                        style={{ display: 'none' }}
                                    />
                                </div>
                                <small>Upload Profile Picture</small>
                                <div className='w-100'>
                                    {errors.profile && <p style={{ color: "red" }}>{errors.profile}</p>}
                                </div>
                            </Grid>
                            {/* Email */}
                            <Grid size={{xs:12}} container>
                                <Grid size={{ sm: 5.5, xs: 12 }} container flexDirection="column" className="memberfield_individual mb-4">
                                    <span>Email Id<small className='red_starimpo'>*</small></span>
                                    <input
                                        type="text"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                    />
                                    {errors.email && <p style={{ color: "red" }}>{errors.email}</p>}
                                </Grid>
                            </Grid>
                            {/* Password */}
                            <Grid size={{ xs: 12 }} container justifyContent="space-between">
                                <Grid size={{ sm: 5.5, xs: 12 }} container flexDirection="column" className="mb-4">
                                    <span>Password</span>
                                    <div className='d-flex input_witheye'>
                                        <input
                                            name="password"
                                            type={passwordVisible ? 'text' : 'password'}
                                            value={formData.password}
                                            onChange={handleInputChange}
                                            autoComplete="new-password"
                                            placeholder="Abcd123#"
                                            style={{ width: '100%', paddingRight: '40px' }}
                                        />
                                        <button type="button" onClick={togglePasswordVisibility}>
                                            {passwordVisible ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                        </button>
                                    </div>
                                    {errors.password && <p style={{ color: "red" }}>{errors.password}</p>}
                                </Grid>
                                {/* Confirm Password */}
                                <Grid size={{ sm: 5.5, xs: 12 }} container flexDirection="column" className="mb-4">
                                    <span>Confirm Password</span>
                                    <div className='d-flex input_witheye'>
                                        <input
                                            name="password_confirmation"
                                            value={formData.password_confirmation}
                                            onChange={handleInputChange}
                                            type={passwordVisible2 ? 'text' : 'password'}
                                            autoComplete="new-password"
                                            placeholder="Abcd123#"
                                            style={{ width: '100%', paddingRight: '40px' }}
                                        />
                                        <button type="button" onClick={togglePasswordVisibility2}>
                                            {passwordVisible2 ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                        </button>
                                    </div>
                                    {errors.password_confirmation && <p style={{ color: "red" }}>{errors.password_confirmation}</p>}
                                </Grid>
                            </Grid>
                            {/* First Name */}
                            <Grid size={{ sm: 5.5, xs: 12 }} container flexDirection="column" className="memberfield_individual mb-4">
                                <span>First Name<small className='red_starimpo'>*</small></span>
                                <input
                                    type="text"
                                    name="first_name"
                                    value={formData.first_name}
                                    onChange={handleInputChange}
                                    onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
                                />
                                {errors.first_name && <p style={{ color: "red" }}>{errors.first_name}</p>}
                            </Grid>
                            {/* Last Name */}
                            <Grid size={{ sm: 5.5, xs: 12 }} container flexDirection="column" className="memberfield_individual mb-4">
                                <span>Last Name<small className='red_starimpo'>*</small></span>
                                <input
                                    type="text"
                                    name="last_name"
                                    value={formData.last_name}
                                    onChange={handleInputChange}
                                    onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}
                                />
                                {errors.last_name && <p style={{ color: "red" }}>{errors.last_name}</p>}
                            </Grid>
                            {/* Date of Birth */}
                            <Grid size={{ sm: 5.5, xs: 12 }} container flexDirection="column" className="memberfield_individual mb-4">
                                <span>Date of Birth<small className='red_starimpo'>*</small></span>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        className="date_pickermux"
                                        value={value}
                                        onChange={handleDateChange}
                                        maxDate={dayjs().subtract(18, 'year').subtract(1, 'day')}
                                        renderInput={(params) => <input {...params} />}
                                    />
                                </LocalizationProvider>
                                {errors.dob && <p style={{ color: "red" }}>{errors.dob}</p>}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                                <span>Manager<small className='red_starimpo'>*</small></span>
                                <Select
                                    className="basic-single select_withsearch"
                                    classNamePrefix="select"
                                    value={selectedManager}
                                    defaultValue={null}
                                    name="manager_id"
                                    options={managerList && managerList.map((managerLists) => ({
                                        label: managerLists.name,
                                        value: managerLists.id,
                                    }))}
                                    onChange={handleManagerChange}
                                />
                                {errors.manager_id && <p style={{color:"red"}}>{errors.manager_id}</p>}
                            </Grid>
                            <Grid size={{xs:12}} container className="mb-4 gap-2">
                                <input className='checkbox_inputes' onChange={(e) => 
                                        handleInputChange({
                                        target: { name: "is_review", value: e.target.checked ? 1 : 0 }
                                        })
                                    } checked={formData.is_review === 1} type='checkbox'/>
                                <span>Allow Reviews</span>
                            </Grid>
                            <Grid size={{ xs: 12 }} container flexDirection="column" className="memberfield_individual mb-4">
                                <span>Address<small className='red_starimpo'>*</small></span>
                                <input
                                    type="text"
                                    name="address"
                                    value={formData.address}
                                    onChange={handleInputChange}
                                />
                                {errors.address && <p style={{ color: "red" }}>{errors.address}</p>}
                            </Grid>
                            {/* Phone Number */}
                            <Grid size={{ sm: 5.5, xs: 12 }} container flexDirection="column" className="memberfield_individual mb-4">
                                <span>Personal Phone Number<small className='red_starimpo'>*</small></span>
                                <PhoneInput
                                    placeholder="Enter phone number"
                                    defaultCountry="US"
                                    countries={allowedCountries}
                                    international={true}
                                    limitMaxLength={true}
                                    value={formData.phone_number}
                                    onChange={(value) => handlePhoneChange(value, "phone_number")}
                                    onKeyDown={(e) => handleKeyDown(e, "phone_number")}
                                    autoComplete="new-password"
                                />
                                {errors.phone_number && <p style={{ color: "red" }}>{errors.phone_number}</p>}
                            </Grid>
                            <Grid size={{ sm: 5.5, xs: 12 }} container flexDirection="column" className="memberfield_individual mb-4">
                                <span>Business Phone Number<small className='red_starimpo'>*</small></span>
                                <PhoneInput
                                    placeholder="Enter phone number"
                                    defaultCountry="US"
                                    countries={allowedCountries}
                                    international={true}
                                    limitMaxLength={true}
                                    value={formData.business_number}
                                    onChange={(value) => handlePhoneChange(value, "business_number")}
                                    onKeyDown={(e) => handleKeyDown(e, "business_number")}
                                    autoComplete="new-password"
                                />
                                {errors.business_number && <p style={{ color: "red" }}>{errors.business_number}</p>}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container>
                                <Grid size={{xs:12}} container className="mb-4" flexDirection="column">
                                    <span>Does this personal phone number support whatsapp ?<small className='red_starimpo'>*</small></span>
                                    <div className='d-flex align-items-center main_radioregister'>
                                        <input
                                        type="radio"
                                        name="is_whatsapp"
                                        value="1"
                                        checked={formData.is_whatsapp === 1}
                                        onChange={(e) => handleInputChange({
                                            target: { name: "is_whatsapp", value: Number(e.target.value) }
                                        })}
                                        /> Yes
                                        <input
                                        type="radio"
                                        name="is_whatsapp"
                                        value="0"
                                        checked={formData.is_whatsapp === 0}
                                        onChange={(e) => handleInputChange({
                                            target: { name: "is_whatsapp", value: Number(e.target.value) }
                                        })}
                                        /> No
                                    </div>
                                    {errors.is_whatsapp && <p style={{color:"Red"}}>{errors.is_whatsapp}</p>}
                                </Grid>
                                {formData.is_whatsapp === 0 &&
                                <Grid size={{xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                                    <span>Personal Whatsapp Number<small className='red_starimpo'>*</small></span>
                                    <PhoneInput
                                        placeholder="Enter phone number"
                                        defaultCountry="US"
                                        countries={allowedCountries}
                                        international={true}
                                        limitMaxLength={true}
                                        value={formData.whatsapp_number}
                                        onChange={(value) => handlePhoneChange(value, "whatsapp_number")}
                                        onKeyDown={(e) => handleKeyDown(e, "whatsapp_number")}
                                        autoComplete="new-password"
                                    />
                                    {errors.whatsapp_number && <p style={{color:"red"}}>{errors.whatsapp_number}</p>}
                                </Grid>
                                }
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container>
                                <Grid size={{xs:12}} container className="mb-4" flexDirection="column">
                                    <span>Does this business phone number support business whatsapp ?<small className='red_starimpo'>*</small></span>
                                    <div className='d-flex align-items-center main_radioregister'>
                                        <input
                                        type="radio"
                                        name="is_business"
                                        value="1"
                                        checked={formData.is_business === 1}
                                        onChange={(e) => handleInputChange({
                                            target: { name: "is_business", value: Number(e.target.value) }
                                        })}
                                        /> Yes
                                        <input
                                        type="radio"
                                        name="is_business"
                                        value="0"
                                        checked={formData.is_business === 0}
                                        onChange={(e) => handleInputChange({
                                            target: { name: "is_business", value: Number(e.target.value) }
                                        })}
                                        /> No
                                    </div>
                                    {errors.is_business && <p style={{color:"Red"}}>{errors.is_business}</p>}
                                </Grid>
                                {formData.is_business === 0 &&
                                <Grid size={{xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                                    <span>Business Whatsapp Number<small className='red_starimpo'>*</small></span>
                                    <PhoneInput
                                        placeholder="Enter number"
                                        defaultCountry="US"
                                        countries={allowedCountries}
                                        international={true}
                                        limitMaxLength={true}
                                        value={formData.business_whatsapp_number}
                                        onChange={(value) => handlePhoneChange(value, "business_whatsapp_number")}
                                        onKeyDown={(e) => handleKeyDown(e, "business_whatsapp_number")}
                                        autoComplete="new-password"
                                    />
                                    {errors.business_whatsapp_number && <p style={{color:"red"}}>{errors.business_whatsapp_number}</p>}
                                </Grid>
                                }
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                                <span>Industry Start Date<small className='red_starimpo'>*</small></span>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        className="date_pickermux"
                                        value={value3}
                                        onChange={handleDateChange3}
                                        maxDate={dayjs().subtract(1, 'day')}
                                        renderInput={(params) => <input {...params} />}
                                    />
                                </LocalizationProvider>
                                {errors.industry_start_date && <p style={{color:"red"}}>{errors.industry_start_date}</p>}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                                <span>Start Date<small className='red_starimpo'>*</small></span>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        minDate={value3}
                                        maxDate={dayjs()}
                                        className="date_pickermux"
                                        value={value2}
                                        onChange={handleDateChange2}
                                        renderInput={(params) => <input {...params} />}
                                    />
                                </LocalizationProvider>
                                {errors.start_date && <p style={{color:"red"}}>{errors.start_date}</p>}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                                <span>Job Title (Linkedin)<small className='red_starimpo'>*</small></span>
                                <input type="text" name="job_title" value={formData.job_title} onChange={handleInputChange} />
                                {errors.job_title && <p style={{color:"red"}}>{errors.job_title}</p>}
                            </Grid>
                            
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="memberfield_individual mb-4">
                                <span>Linkedin URL<small className='red_starimpo'>*</small></span>
                                <input type="text" name="linkedin_url" value={formData.linkedin_url} onChange={handleInputChange} />
                                {errors.linkedin_url && <p style={{color:"red"}}>{errors.linkedin_url}</p>}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="regiter_inputs mb-4">
                                <span className='mt-0'>Partnership Status<small className='red_starimpo'>*</small></span>
                                <select name="partnership_status" value={formData.partnership_status} onChange={handleInputChange}>
                                    <option value="">Select Partnership Status</option>
                                    <option value="Senior Partner">Senior Partner</option>
                                    <option value="Junior Partner">Junior Partner</option>
                                    <option value="Senior Associates">Senior Associates</option>
                                    <option value="Junior Associates">Junior Associates</option>
                                    <option value="Not a Partner">Not a Partner</option>
                                </select>
                                {errors.partnership_status && <p style={{color:"red"}}>{errors.partnership_status}</p>}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="regiter_inputs mb-4">
                                <span className='mt-0'>Primary Department<small className='red_starimpo'>*</small></span>
                                <select name="primary_department" value={formData.primary_department} onChange={handleInputChange}>
                                    <option value="">Select Primary Department</option>
                                    <option value="BSD/FSD">BSD/FSD</option>
                                    <option value="ITRD">ITRD</option>
                                    <option value="HRAC">HRAC</option>
                                    <option value="PRCA">PRCA</option>
                                    <option value="PV">PV</option>
                                </select>
                                {errors.primary_department && <p style={{color:"red"}}>{errors.primary_department}</p>}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column" className="regiter_inputs mb-4">
                                <span className='mt-0'>Industry Sector<small className='red_starimpo'>*</small></span>
                                <select name="industry_sector" value={formData.industry_sector} onChange={handleInputChange}>
                                    <option value="">Select Industry Sector</option>
                                    <option value="Staffing & Recruitment">Staffing & Recruitment</option>
                                    <option value="Information Technology">Information Technology</option>
                                    <option value="Human Resources & Accounts">Human Resources & Accounts</option>
                                    <option value="Client Acquisition & Public Relations">Client Acquisition & Public Relations</option>
                                </select>
                                {errors.industry_sector && <p style={{color:"red"}}>{errors.industry_sector}</p>}
                            </Grid>
                            <Grid size={{xs:12}} container className="mb-4 gap-2" flexDirection="column">
                                <div style={{ width: "max-content", display: "flex", flexDirection: "column", alignItems: "flex-end"}}>
                                    <div
                                        ref={signatureRef}
                                        style={{
                                        fontFamily: "Arial, sans-serif",
                                        color: "#000",
                                        backgroundColor: "#fff",
                                        borderRadius: "10px",
                                        padding: "16px",
                                        width: "400px",
                                        }}
                                    >
                                        <div style={{ display: "flex", alignItems: "flex-start" }}>
                                            {preview ? (
                                                <img src={preview} alt="Profile" style={{ borderRadius: "50%", width: "70px", height: "70px" }} />
                                            ) : (
                                                <img src={require('../../assets/defaultprofile.png')} alt="Profile" style={{ borderRadius: "50%", width: "70px", height: "70px" }} />
                                            )}
                                            <p style={{ marginTop: "10px",marginLeft: "15px", fontSize: "14px" }}>
                                                Connect with us: <br/>
                                                <a href={`${subAdminData.instagram_link}`} style={{ marginRight:"10px" }} target="_blank" rel="noopener noreferrer">
                                                    <img
                                                    src={require("../../assets/instagram_email.png")}
                                                    alt="globe"
                                                    style={{ width: "30px" , height: "30px"}}
                                                /></a>
                                                {formData.linkedin_url &&
                                                    <a href={`${formData.linkedin_url}`} target="_blank" rel="noopener noreferrer"><img
                                                        src={require("../../assets/linkedin_email.png")}
                                                        alt="globe"
                                                        style={{width: "30px" , height: "30px" }}
                                                    /></a>
                                                }
                                            </p>
                                            <img
                                                src={subAdminData.techpossible_logo}
                                                alt="Profile"
                                                style={{marginLeft: "15px", width: "160px" }}
                                            />
                                        </div>
                                        <div style={{marginTop: "15px", display: "flex", alignItems: "start" }}>
                                            <div style={{ marginLeft: "15px", fontSize: "14px"  }}>
                                                <div style={{ marginBottom: "15px" }}>
                                                    <h5 style={{ margin: "0", color: "#000",fontWeight:"600" }}>{formData.first_name} {formData.last_name}</h5>
                                                    <p style={{ margin: "2px 0", fontSize: "14px" }}>
                                                        {formData.partnership_status && formData.partnership_status !== "Not a Partner" ? <>
                                                            {formData.partnership_status} @{formData.industry_sector}</>: <>{formData.job_title && <>{formData.job_title} @{formData.industry_sector}</>}</>}
                                                    </p>
                                                </div>
                                                {subAdminData.company_address && <p style={{display:"flex"}}><img
                                                src={require("../../assets/email_navigation.png")}
                                                alt="navi"
                                                style={{ width: "16px" ,marginRight: "8px", height: "16px" }}
                                            /> <span style={{width:"calc(100% - 24px)"}}>{subAdminData.company_address}</span></p>}
                                                <p><img
                                                    src={require("../../assets/email_at_sign.png")}
                                                    alt="email"
                                                    style={{ width: "16px" ,marginRight: "8px", height: "16px" }}
                                                /> <a href={`mailto:${formData.email}`} target="_blank" rel="noopener noreferrer">{formData.email}</a></p>
                                                {formData.business_number &&<p><img
                                                    src={require("../../assets/email_phone.png")}
                                                    alt="phone"
                                                    style={{ width: "16px" ,marginRight: "8px", height: "16px" }}
                                                /> 
                                                    <a href={`tel:${formData.business_number}`} target="_blank" rel="noopener noreferrer">{formData.business_number}</a></p>}
                                                <p style={{marginBottom:"0px"}}><img
                                                    src={require("../../assets/email_globe.png")}
                                                    alt="globe"
                                                    style={{ width: "16px" ,marginRight: "8px", height: "16px" }}
                                                /> <a href={`https://${subAdminData.website_link}`} target="_blank" rel="noopener noreferrer">{subAdminData.website_link}</a></p>
                                            </div>
                                        </div>
                                    </div>
                                    <button type='button'
                                        onClick={handleCopy}
                                        style={{
                                        background: "#fff",
                                        color: "#c2185b",
                                        border: "none",
                                        fontWeight:500,
                                        padding: "5px 12px",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                        marginBottom: "10px",
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faCopy} />  Copy
                                    </button>
                                </div>
                            </Grid>
                            {errorsmessage && <p style={{ color: "red", textAlign: "center" }}>{errorsmessage}</p>}
                            {/* Submit Button */}
                            <Grid size={{sm:12,xs:12}} container justifyContent="flex-end" className="gap-lg-5 gap-3 my-3">
                                <button type="button" className='registersendbtn1 my-0' onClick={()=>navigate("/user/member")}>Cancel</button>
                                {UserRoles === "admin" && <>
                                <button type="button" className='registersendbtn1 my-0' onClick={() => handleShow(id)}>Delete</button>
                                <button
                                    type="button"
                                    className='registersendbtn1 my-0'
                                    onClick={() => handleSuspend(id, suspends === 1)}
                                >
                                    {suspendLoader ? <img src={require('../../assets/pinkloader.gif')} alt=''/> : <>{suspends === 0 ? "Suspend" : "UnSuspend"}</>}
                                    
                                </button>
                                </>}
                                <button type="submit" className='registersendbtn2 my-0'>{btnloading ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Save'}</button>
                            </Grid>
                        </Grid>
                    </form>
                    <Grid size={{sm:11,xs:12}} container justifyContent="flex-start" className="statusselectbtn">
                        <div className='admintab_btnredirect'>
                            <button className={activeTab === "group" ? "active_tabbtn" : ""} onClick={() =>{setActiveTab("group")}}>Groups</button>
                            <button className={activeTab === "permissions" ? "active_tabbtn" : ""} onClick={() =>{setActiveTab("permissions")}} >Permissions</button>
                            <button className={activeTab === "kbaccess" ? "active_tabbtn" : ""} onClick={() =>{setActiveTab("kbaccess")}} >KB Access</button>
                        </div>
                    </Grid>
                    {tabLoading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :<>
                    {activeTab === "group" ?
                        <Grid size={{sm:11,xs:12}} container className="mt-4 pb-3" style={{height:"fit-content"}}>
                            <Grid size={{xs:12}} container alignItems="center" justifyContent="space-between">
                                <h4 className='my-3'>Groups</h4>
                            </Grid>
                            <Grid size={{xs:12}} className="datatable_jobpagi">
                                <DataGrid
                                    style={{minHeight:"200px"}}
                                    rows={rows2}
                                    columns={columns2}
                                    disableSelectionOnClick
                                    components={{ Toolbar: GridToolbar }}
                                />
                            </Grid>
                            <Grid size={{xs:12}} container justifyContent="space-between">
                                <div className='d-flex justify-content-end align-items-center mt-3'>
                                    <label className='me-2'>Showing records <b>{paginatedata2.from}</b>-<b>{paginatedata2.to}</b> out of <b>{paginatedata2.total}</b></label>
                                </div>
                                <div className='d-flex justify-content-end datatable_jobpagi align-items-center mt-3'>
                                    <label className='me-2'>No. of Rows</label>
                                    <select
                                        label="Rows per page"
                                        value={selectedRecord2 || 20}
                                        onChange={(e) => {
                                            const value = Number(e.target.value);
                                            setShowRecord2(value);
                                            setCurrentPage2(1);
                                        }}
                                        sx={{ mr: 2 }}
                                    >
                                        {[5, 10, 20, 50].map((size) => (
                                            <option key={size} value={size}>{size}</option>
                                        ))}
                                    </select>
                                </div>
                            </Grid>
                            <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                                <button className='arrowpaginate'
                                    onClick={() => handlePageChange2(currentPage2 - 1)} 
                                    disabled={currentPage2 === 1}>
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                </button>
                                {paginatedata2 && paginatedata2.last_page > 0 && (
                                    <div className="pagination">
                                        {(() => {
                                        const totalPages = Math.max(1, paginatedata2.last_page);
                                        const pages = [];
            
                                        const start = Math.max(2, currentPage2 - 2);
                                        const end = Math.min(totalPages - 1, currentPage2 + 2);
            
                                        // Always show page 1
                                        pages.push(
                                            <button
                                            key={1}
                                            onClick={() => handlePageChange2(1)}
                                            className={currentPage2 === 1 ? 'active' : ''}
                                            >
                                            1
                                            </button>
                                        );
            
                                        // Ellipsis after page 1 if needed
                                        if (start > 2) {
                                            pages.push(<span key="start-ellipsis">...</span>);
                                        }
            
                                        // Middle pages
                                        for (let i = start; i <= end; i++) {
                                            pages.push(
                                            <button
                                                key={i}
                                                onClick={() => handlePageChange2(i)}
                                                className={currentPage2 === i ? 'active' : ''}
                                            >
                                                {i}
                                            </button>
                                            );
                                        }
            
                                        // Ellipsis before last page if needed
                                        if (end < totalPages - 1) {
                                            pages.push(<span key="end-ellipsis">...</span>);
                                        }
            
                                        // Always show last page (if more than 1)
                                        if (totalPages > 1) {
                                            pages.push(
                                            <button
                                                key={totalPages}
                                                onClick={() => handlePageChange2(totalPages)}
                                                className={currentPage2 === totalPages ? 'active' : ''}
                                            >
                                                {totalPages}
                                            </button>
                                            );
                                        }
            
                                        return pages;
                                        })()}
                                    </div>
                                )}
                                <button className='arrowpaginate'
                                    onClick={() => handlePageChange2(currentPage2 + 1)} 
                                    disabled={currentPage2 === paginatedata2 && paginatedata2.last_page}>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </Grid>
                        </Grid> :
                        activeTab === "permissions" ?
                        <Grid size={{sm:11,xs:12}} container className="mt-4 pb-3" style={{height:"fit-content"}}>
                            <Grid size={{xs:12}} container alignItems="center" justifyContent="space-between">
                                <h4 className='my-3'>Permissions</h4>
                            </Grid>
                            <Grid size={{xs:12}} className="datatable_jobpagi">
                                <DataGrid
                                    style={{minHeight:"200px"}}
                                    rows={rows}
                                    columns={columns}
                                    disableSelectionOnClick
                                    components={{ Toolbar: GridToolbar }}
                                />
                            </Grid>
                            <Grid size={{xs:12}} container justifyContent="space-between">
                                <div className='d-flex justify-content-end align-items-center mt-3'>
                                    <label className='me-2'>Showing records <b>{paginatedata.from}</b>-<b>{paginatedata.to}</b> out of <b>{paginatedata.total}</b></label>
                                </div>
                                <div className='d-flex justify-content-end datatable_jobpagi align-items-center mt-3'>
                                    <label className='me-2'>No. of Rows</label>
                                    <select
                                        label="Rows per page"
                                        value={selectedRecord || 20}
                                        onChange={(e) => {
                                            const value = Number(e.target.value);
                                            setShowRecord(value);
                                            setCurrentPage(1);
                                        }}
                                        sx={{ mr: 2 }}
                                    >
                                        {[5, 10, 20, 50].map((size) => (
                                            <option key={size} value={size}>{size}</option>
                                        ))}
                                    </select>
                                </div>
                            </Grid>
                            <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                                <button className='arrowpaginate'
                                    onClick={() => handlePageChange(currentPage - 1)} 
                                    disabled={currentPage === 1}>
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                </button>
                                {paginatedata && paginatedata.last_page > 0 && (
                                    <div className="pagination">
                                        {(() => {
                                        const totalPages = Math.max(1, paginatedata.last_page);
                                        const pages = [];
            
                                        const start = Math.max(2, currentPage - 2);
                                        const end = Math.min(totalPages - 1, currentPage + 2);
            
                                        // Always show page 1
                                        pages.push(
                                            <button
                                            key={1}
                                            onClick={() => handlePageChange(1)}
                                            className={currentPage === 1 ? 'active' : ''}
                                            >
                                            1
                                            </button>
                                        );
            
                                        // Ellipsis after page 1 if needed
                                        if (start > 2) {
                                            pages.push(<span key="start-ellipsis">...</span>);
                                        }
            
                                        // Middle pages
                                        for (let i = start; i <= end; i++) {
                                            pages.push(
                                            <button
                                                key={i}
                                                onClick={() => handlePageChange(i)}
                                                className={currentPage === i ? 'active' : ''}
                                            >
                                                {i}
                                            </button>
                                            );
                                        }
            
                                        // Ellipsis before last page if needed
                                        if (end < totalPages - 1) {
                                            pages.push(<span key="end-ellipsis">...</span>);
                                        }
            
                                        // Always show last page (if more than 1)
                                        if (totalPages > 1) {
                                            pages.push(
                                            <button
                                                key={totalPages}
                                                onClick={() => handlePageChange(totalPages)}
                                                className={currentPage === totalPages ? 'active' : ''}
                                            >
                                                {totalPages}
                                            </button>
                                            );
                                        }
            
                                        return pages;
                                        })()}
                                    </div>
                                )}
                                <button className='arrowpaginate'
                                    onClick={() => handlePageChange(currentPage + 1)} 
                                    disabled={currentPage === paginatedata.last_page}>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </Grid>
                        </Grid> :
                        <Grid size={{sm:11,xs:12}} container className="mt-4 pb-3" style={{height:"fit-content"}}>
                            <Grid size={{xs:12}} container alignItems="center" justifyContent="space-between">
                                <h4 className='my-3'>KB Access</h4>
                            </Grid>
                            <KbAccessMemeber/>
                        </Grid>
                    }</>}
                </>}
            </Grid>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this Sub Admin?</Modal.Body>
                <Modal.Footer>
                    <button className='modal_cancel' onClick={handleClose}>
                        Cancel
                    </button>
                    <button className='modal_delete' onClick={handleDelete}>
                        {deleteLoader ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Delete'}
                    </button>   
                </Modal.Footer>
            </Modal>
        </div>
    </div>
  )
}

export default UserMemberEdit
